"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 管理番号を0詰め文字列で返す.
 * @param {Number} reportNo 管理番号
 * @param {boolean} prefix 前置文字列（necg）を付ける場合true
 * @returns 管理番号
 */
const getFormattedReportNo = (reportNo, prefix) => {
  const KETA = 5;
  if (reportNo) {
    return (prefix ? 'necg' : _stringConsts.STRING_CONSTS.EMPTY) + ('00000' + reportNo).slice(KETA * -1);
  }
  return _stringConsts.STRING_CONSTS.EMPTY;
};

/**
 * 会社名と組織名を全角スラッシュ区切りで連結した文字列を返す
 * @param {string} kaishaNm 会社名
 * @param {string} soshikiNm 組織名
 * @returns 連結した会社組織名
 */
const joinKaishaSoshikiNm = (kaishaNm, soshikiNm) => {
  return joinStringPart([kaishaNm, soshikiNm], _stringConsts.STRING_CONSTS.SLASH_ZENKAKU);
};

/**
 * 配列で指定された要素を連結した文字列を返す
 * @param {Array} parts 文字列の配列
 * @param {string} sep 区切り文字
 * @param {boolean} [emptyToHyphen=false] true:文字列が空のときに全角ハイフンに置き換える
 * @param {boolean} [emptySquash=true] true:文字列が空のときに詰める
 * @returns 連結した文字列
 */
const joinStringPart = function (parts, sep) {
  let emptyToHyphen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let emptySquash = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  const array = parts.map(a => {
    return emptyToHyphen ? _stringUtil.default.emptyToHyphen(a) : a;
  });
  return emptySquash ? array.filter(a => a).join(sep) : array.join(sep);
};

/**
 * 添付ファイルの確認中フラグキーを返す
 * @param {string} fileTypeCd ファイル種別コード
 * @returns 添付ファイルの確認中フラグキー
 */
const getAttachedFileCheckingFlgKey = fileTypeCd => {
  return 'attachedFile' + fileTypeCd;
};
const pandeReportUtil = {
  getFormattedReportNo,
  joinKaishaSoshikiNm,
  joinStringPart,
  getAttachedFileCheckingFlgKey
};
var _default = exports.default = pandeReportUtil;